import {ControllerFlowAPI} from '@wix/yoshi-flow-editor'
import {Details} from '@wix/ambassador-table-reservations-v1-reservation/types'
import {zonedTimeToUtc} from '@wix/table-reservations-lib/timezone'

import {reservationsService} from '../../../services/reservationsService'
import {goToReservationDetails} from '../../../utils/navigation'
import {RequestStatus} from '../../../utils/wrapRequest'
import {TransactionNames} from '../../../utils/constants'

export const handleReservationData = (flowAPI: ControllerFlowAPI) => {
  return async ({
    details,
    timeZone,
    isManualApproval,
  }: {
    details: Details
    timeZone: string | null
    isManualApproval: boolean
  }) => {
    const reservationDetails = {
      ...details,
      startDate: zonedTimeToUtc(details.startDate!, timeZone),
    }

    const handleReservationTransaction = flowAPI.panoramaClient.transaction(
      TransactionNames.handleReservation,
    )

    handleReservationTransaction.start({
      params: {
        isManualApproval,
        reservationDetails,
      },
    })

    const setProps = flowAPI.controllerConfig.setProps
    const {getResolvedError} = flowAPI.errorHandler

    try {
      setProps({
        handleReservationDataStatus: RequestStatus.LOADING,
        handleReservationDataError: undefined,
      })

      if (isManualApproval) {
        await goToReservationDetails({
          flowAPI,
          timeZone,
          reservationData: {
            startDate: zonedTimeToUtc(details.startDate!, timeZone),
            partySize: details.partySize!,
            reservationLocationId: details.reservationLocationId!,
            areaId: details.areaId,
          },
        })
      } else {
        const data = await reservationsService.holdReservation(flowAPI, reservationDetails)

        await goToReservationDetails({flowAPI, reservationId: data?.id, areaId: details.areaId})
      }
    } catch (err: any) {
      flowAPI.panoramaClient.errorMonitor().reportError(err)

      const resolvedError = getResolvedError(err)
      if (resolvedError.applicationError?.code !== 'TIME_NOT_AVAILABLE') {
        resolvedError.message = flowAPI.translations.t(
          'uou-reservations.reservations.not-accepting-contact-by-phone',
        )
      }
      setProps({
        handleReservationDataStatus: RequestStatus.FAILED,
        handleReservationDataError: resolvedError,
      })
    }

    handleReservationTransaction.finish()
  }
}
